import React from "react";

import { GroupIcon } from "./groupIcon";
import { Props } from "./types";
import { Completion } from "./completion";
import { AllocatedHours } from "./allocatedHours";
import styles from "./styles.scss";

function Group({ group }: Props) {
  const { allocatedHours, percentComplete: totalPercentComplete } =
    group.allocations.reduce(
      (total, allocation) => ({
        allocatedHours: total.allocatedHours + allocation.allocatedHours,
        percentComplete: total.percentComplete + allocation.percentComplete,
      }),
      {
        allocatedHours: 0,
        percentComplete: 0,
      },
    );
  const percentComplete =
    group.resources.length === 0
      ? 0
      : totalPercentComplete / group.resources.length;

  return (
    <div className={styles.group}>
      <div className={styles.resource}>
        <div className={styles.completionCheck} />
        <div className={styles.avatar}>
          <GroupIcon className={styles.icon} />
        </div>
        <div className={styles.user}>
          <p className={styles.name}>{group.name}</p>
        </div>
      </div>
      <div className={styles.container}>
        <AllocatedHours
          allocatedHours={allocatedHours}
          submit={(allocatedHours) => {}}
          readOnly
        />
      </div>
      <div>
        <div className={styles.container}>
          <Completion
            completion={percentComplete}
            submit={(percentComplete) => {}}
            readOnly
          />
        </div>
      </div>
      <div className={styles.removeAllocation}>
        <div className={styles.binIcon} />
      </div>
    </div>
  );
}

export { Group };
